import { render, staticRenderFns } from "./Bkg.vue?vue&type=template&id=999fb058&scoped=true&"
import script from "./Bkg.vue?vue&type=script&lang=js&"
export * from "./Bkg.vue?vue&type=script&lang=js&"
import style0 from "./Bkg.vue?vue&type=style&index=0&id=999fb058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999fb058",
  null
  
)

export default component.exports